import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative bg-brand-green overflow-hidden px-4 md:px-6 pt-6 md:pt-10 pb-10 md:pb-14 text-center" data-id="element-51">
      {/* Subtle radial highlight */}
      <div aria-hidden className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at 70% 30%, rgba(255,255,255,0.06) 0%, transparent 60%)'
    }} data-id="element-52" />

      <div className="relative max-w-4xl mx-auto" data-id="element-53">
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-block bg-white/10 text-white/85 text-[10px] md:text-[11px] font-semibold tracking-[0.14em] uppercase px-3.5 md:px-4 py-1.5 rounded-full mb-3 md:mb-5" data-id="element-54">
          Para fonoaudiólogas independientes · Argentina
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="font-serif text-brand-white text-[24px] sm:text-3xl md:text-[44px] font-bold leading-[1.15] tracking-tight text-balance mb-3 md:mb-4" data-id="element-55">
          Estudiaste años para atender pacientes.
          <br data-id="element-56" />
          <em className="italic font-normal text-white/75" data-id="element-57">
            Pero terminás el día escribiendo lo mismo que escribiste ayer.
          </em>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.92,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.15
      }} className="flex justify-center mb-3 md:mb-4" data-id="element-58">
          <img src="https://cdn.magicpatterns.com/uploads/7Xq7arWuAYKVkP18X9wNCk/ChatGPT_Image_2_jun_2026__21_58_10-removebg-preview.png" alt="Consultorio Fono en Orden — Kit profesional para fonoaudiólogas: 6 tomos + 6 bonos" className="w-full max-w-[200px] sm:max-w-xs md:max-w-md drop-shadow-[0_20px_40px_rgba(0,0,0,0.35)]" data-id="element-59" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-white/75 text-[13px] md:text-base font-light max-w-xl mx-auto leading-snug md:leading-relaxed mb-4 md:mb-6" data-id="element-60">
          Consultorio Fono en Orden — el kit de gestión clínica que te ahorra
          horas de trabajo por semana, desde el primer día que lo descargás.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="flex flex-col items-center" data-id="element-61">
          <a href="#pricing" className="inline-block bg-brand-gold hover:bg-brand-gold-dark text-white font-semibold text-[14px] md:text-base px-7 md:px-10 py-3.5 md:py-[16px] rounded-md tracking-wide transition-all hover:-translate-y-0.5 shadow-[0_4px_24px_rgba(0,0,0,0.25)] hover:shadow-[0_8px_32px_rgba(0,0,0,0.3)]" data-id="element-62">
            → QUIERO MI KIT AHORA
          </a>

          <p className="mt-3 md:mt-4 text-white/55 text-[11px] md:text-[13px]" data-id="element-63">
            Pago único · Acceso y descarga inmediata · Sin suscripción
          </p>
          <p className="mt-1 text-white/55 text-[11px] md:text-[13px]" data-id="element-64">
            Garantía de 7 días — si no te sirve, te devolvemos el 100%
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.45
      }} className="flex flex-wrap items-center justify-center gap-2 md:gap-3 mt-6 md:mt-8" data-id="element-65">
          {['100% PDF', 'Acceso al instante', 'Para fonoaudiólogas'].map(label => <span key={label} className="bg-white/10 border border-white/15 text-white/80 text-[10px] md:text-xs font-medium tracking-wide px-3 md:px-4 py-1.5 md:py-2 rounded-full" data-id="element-66">
                {label}
              </span>)}
        </motion.div>
      </div>
    </section>;
}